import React from "react";
import { inject, observer } from "mobx-react";

import CreateAtendee from "./modals/CreateAtendee";
import EditAtendee from "./modals/EditAtendee";
import SearchAtendee from "./modals/SearchAtendee";
import EmailTemplate from "./modals/EmailTemplate";

import QuizQuestions from "./modals/QuizQuestions";

@inject("modal")
@observer
export default class ModalOverlay extends React.Component {
  showContent = () => {
    if (this.props.modal.modalContent == "search_attendee") {
      return <SearchAtendee />;
    }

    if (this.props.modal.modalContent == "create_atendee") {
      return <CreateAtendee />;
    }

    if (this.props.modal.modalContent == "edit_attendee") {
      return <EditAtendee />;
    }

    if (this.props.modal.modalContent == "email_template") {
      return <EmailTemplate />;
    }

    if (this.props.modal.modalContent == "quiz_questions") {
      return <QuizQuestions />;
    }
  };

  render() {
    if (this.props.modal.showModal) {
      return <div className="modal-overlay">{this.showContent()}</div>;
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalOverlay.jsx